import { Box, SkeletonRectangle } from '@wix/design-system';
import React from 'react';
import { StudioPackagePickerModule } from '../../../modules/studio-package-picker.module';
import { DefaultPromotionalMessage } from './DefaultPromotionalMessage';
import { UpgradePromotionalMessage } from './UpgradePromotionalMessage';

export const PromotionalMessage = () => {
  const { data: switchFlowData, isLoading: isSwitchFlowLoading } =
    StudioPackagePickerModule.SDK.switchApiClient.hooks.useIsSwitchFlow({});

  if (isSwitchFlowLoading) {
    return (
      <Box align="center">
        <SkeletonRectangle height="24px" width="300px" />
      </Box>
    );
  }

  const isSwitchFlow = switchFlowData?.isSwitchFlow;
  // TODO: should check if isSwitchFlow is upgrade and not change plan. how will we do it? query param?
  if (isSwitchFlow) {
    return <UpgradePromotionalMessage />;
  }

  return <DefaultPromotionalMessage />;
};
